import "./vision.css";
import Visionimg from "../../img/vision.png";
import { content } from "../../content/landingContent";

const Vision = () => {
  const { titleLines, lead, bullets, close } = content.vision;

  return (
    <section id="vision">
      <div className="a">
        <div className="a-left">
          <div className="a-card">
            <img src={Visionimg} alt="vision_img" className="a-img" />
          </div>
        </div>
        <div className="a-right">
          <div className="a-title">
            {titleLines.map((line, index) => (
              <span key={line}>
                {index > 0 ? <br /> : null}
                {line}
              </span>
            ))}
          </div>
          {lead ? (
            <>
              <p className="i-desc">
                <b>{lead}</b>
              </p>
              <br />
            </>
          ) : null}
          {bullets.map((bullet) => (
            <p className="a-desc" key={bullet}>
              {bullet}
            </p>
          ))}
          {close ? (
            <>
              <br />
              <p className="i-desc">
                <b> {close}</b>
              </p>
            </>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default Vision;
